// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".explore-list[data-v-3f739bc1]  p:nth-child(2n+2){border-bottom:1px solid #e1e2e4}.ui-dark .explore-list[data-v-3f739bc1]  p:nth-child(2n+2){border-bottom-color:#2a2b3a}@media(min-width: 1920px){.explore-list[data-v-3f739bc1]{font-size:1.25rem;line-height:2rem}.explore-list[data-v-3f739bc1]  p:not(:last-child){margin-bottom:1.5rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
